import React from 'react';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Stack, Typography } from '@mui/material';

import type { MarketingRouterMetricResult } from '@luxuryescapes/contract-svc-promo/marketing-router/admin';

import { type ComparisonVariantRow, isMetricResultUnreliable } from './marketingRouterComparison';
import { formatRelativeLift } from './marketingRouterSignificanceDisplay';

function liftColor(result: MarketingRouterMetricResult): string {
  // A reading svc-promo marked invalid gets no colour: green on a rule whose
  // traffic split is broken reads as a result worth shipping.
  if (isMetricResultUnreliable(result) || result.verdict !== 'SIGNIFICANT') {
    return 'text.primary';
  }

  return result.absoluteLift >= 0 ? 'success.main' : 'error.main';
}

export default function MarketingRouterComparisonLiftCell({ row }: { row: ComparisonVariantRow }) {
  if (row.isControl) {
    return (
      <Typography variant="body2" color="text.secondary">
        Baseline
      </Typography>
    );
  }
  if (row.relativeLift === null || row.result === null) {
    return <Typography variant="body2">—</Typography>;
  }
  const Icon = row.result.absoluteLift >= 0 ? ArrowUpwardIcon : ArrowDownwardIcon;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Icon fontSize="inherit" sx={{ color: liftColor(row.result) }} />
      <Typography variant="body2" sx={{ fontWeight: 600, color: liftColor(row.result) }}>
        {formatRelativeLift(row.relativeLift)}
      </Typography>
    </Stack>
  );
}
